<app-menu class="menuApp" xmlns="http://www.w3.org/1999/html"></app-menu>
<div class="main">
  <div style="width: 90%; height: 100%; margin: auto; padding-top: 2vh">


    <div (click)="toIndicators()" class="row deviceSection">
      <div class="deviceHeader">
        <h1 class="centerVert textXXM">{{this.localiser.get("indicators.presences")}}</h1>
      </div>
    </div>

    <div class="bodyChart">

      <!-- PRESENCE -->
      <div style="height: 100%;">

        <div class="filterRow">
          <div class="col-4" style="margin: auto">
            <h3 class="textS+" style="color: #18264f; margin: auto">{{this.localiser.get('devices.searcher')}}</h3>
            <div class="searcherDiv">
              <div class="col-2" style="text-align: right">
                <span class="material-icons-outlined textXM centerVert" style="color: #18264f">
                  search
                </span>
              </div>
              <div class="col" style="text-align: left;">
                <input [(ngModel)]="searcherLuminarias"  (input)="searcherLuminariasFunc()" type="text"
                       class="centerVert textS searcherInput" placeholder=" " maxlength="50">
              </div>
            </div>
          </div>

          <div class="col-4" style="margin: auto">
            <h3 class="textS+" style="color: #18264f">{{this.localiser.get("indicators.floorplan")}}</h3>
            <mat-select id="indicators-presences-select-floorplan" class="upperButton textS" (selectionChange)="selectPlano($event.value)" [(ngModel)]="planoSelected">
              <mat-option class="textS" [value]="-1">All</mat-option>
              <mat-option class="textS" *ngFor="let plano of planos"
                          [value]="plano">{{plano.nombre}}</mat-option>
            </mat-select>
          </div>
          <div class="col-4" style="margin: auto">
            <h3 class="textS+" style="color: #18264f">{{this.localiser.get("indicators.zone")}}</h3>
            <mat-select class="upperButton textS" (selectionChange)="selectZona($event.value)" [(ngModel)]="zonaSelected">
              <mat-option class="textS" [value]="-1">All</mat-option>
              <mat-option class="textS" *ngFor="let zona of showZonas" [value]="zona">{{zona.nombre}}</mat-option>
            </mat-select>
          </div>
        </div>

        <div class="row" style="height: 100%; margin-top: 2%">
          <div class="col-4">
            <div class="col luminariasList">
              <h4 class="textS+" style="text-decoration: underline">
                {{this.localiser.get("indicators.sensorList")}}
              </h4>
              <div *ngFor="let sensor of this.sensores; index as i" class="luminariaBox">
                <div (click)="changeSelectSensor(sensor)" class="luminariaRow"
                     [ngClass]="{'selectedRow': checkSelectedSensor(sensor)}">
                  <h6 class="textS" style="text-decoration: underline; margin: 1% auto"> {{sensor.nombre}} </h6>
                  <h6 class="textS" style="margin: 1% auto"> {{sensor.idLuminaria}} </h6>
                </div>
                <h6 *ngIf="isSensorLoaded(sensor.idLuminaria)" class="textS" style="width: 10%; margin: auto">
                  {{countPresencias(sensor.idLuminaria)}}
                </h6>
                <div *ngIf="!isSensorLoaded(sensor.idLuminaria)" style="width: 10%; margin: auto">
                  <mat-progress-spinner style="margin: auto" class="marginAuto" color="primary" mode="indeterminate" diameter="20">
                  </mat-progress-spinner>
                </div>
              </div>
            </div>
            <div style="margin: 2vh auto; text-align: center">
              <span (click)="unselectAllSensors()" class="material-icons-outlined textXXM unselectAllSensors">
                hide_source
              </span>
            </div>
          </div>
          <div class="col-7">
            <div class="row" style="height: 65%">
              <canvas id="presenciasChart"></canvas>
            </div>
            <div class="row textS" style="height: 15%; margin: auto; width: fit-content">
              <button class="leftButton" (click)="changePresenciasFilterTime(1)"
                      [ngClass]="{'selectedButton': this.presenciasFilterTime == 1}">{{this.localiser.get('indicators.today')}}</button>
              <button class="centerButton" (click)="changePresenciasFilterTime(2)"
                      [ngClass]="{'selectedButton': this.presenciasFilterTime == 2}">{{this.localiser.get('indicators.yesterday')}}</button>
              <button class="centerButton" (click)="changePresenciasFilterTime(3)"
                      [ngClass]="{'selectedButton': this.presenciasFilterTime == 3}">{{this.localiser.get('indicators.week')}}</button>
              <button class="centerButton" (click)="changePresenciasFilterTime(4)"
                      [ngClass]="{'selectedButton': this.presenciasFilterTime == 4}">{{this.localiser.get('indicators.month')}}</button>
              <button class="centerButton" (click)="changePresenciasFilterTime(5)"
                      [ngClass]="{'selectedButton': this.presenciasFilterTime == 5}">{{this.localiser.get('indicators.year')}}</button>
              <button class="rightButton" (click)="changePresenciasFilterTime(6)"
                      [ngClass]="{'selectedButton': this.presenciasFilterTime == 6}">{{this.localiser.get('indicators.custom')}}</button>
            </div>
            <div *ngIf="presenciasFilterTime == 6" class="row" style="height: 10%; margin: auto; width: fit-content">
              <div class="col-5">
                <h6 class="textS">{{this.localiser.get('indicators.start')}}</h6>
                <input type="datetime-local" [(ngModel)]="startCustomTime">
              </div>
              <div class="col-5">
                <h6 class="textS">{{this.localiser.get('indicators.end')}}</h6>
                <input type="datetime-local" [(ngModel)]="endCustomTime">
              </div>
              <div class="col-2">
                <button [disabled]="checkDisabledCustom()"
                        [ngClass]="{customButtonColorReverseDisabled: checkDisabledCustom()}"
                        class="customButtonColorReverse textS" mat-button (click)="this.changePresenciasFilterTime(6)">
                  {{this.localiser.get('button.update')}}
                </button>
              </div>
            </div>
          </div>
        </div>

      </div>

    </div>


  </div>
</div>
